// @ngInject
function AcpPaywallNegativeBalanceCtrl(
  $scope,
  nsUtil,
  acpFeatureModel,
  $window
) {
  function init() {
    acpFeatureModel.hasFeature('acp:savings-paywall-is-netspend').then(
      function (result) {
        $scope.isNetspend = result;
      },
      function () {
        $scope.isNetspend = false;
      }
    );
  }

  $scope.shouldShowTitle = function () {
    if (!nsUtil.isDefined($scope.showTitle)) {
      return true;
    }

    return $scope.showTitle === 'true';
  };

  // open link in mobile browser instead of app
  $scope.openExternalLink = function (e) {
    if (navigator && navigator.userAgent.includes('reactNativeWebview')) {
      e.preventDefault();
      if (e.target && e.target.href) {
        $window.ReactNativeWebView.postMessage(
          JSON.stringify({ externalLink: e.target.href })
        );
      }
    }
  };

  init();
}

export default AcpPaywallNegativeBalanceCtrl;
